import React from "react";
import { useFela } from "react-fela";

import { useTheme } from "@/hooks/useTheme";

interface IConverterFeaturesTableHeader {
  header: string[];
}

export const ConverterFeaturesTableHeader: React.FC<IConverterFeaturesTableHeader> = ({
  header,
}) => {
  const { css } = useFela();
  const { colors } = useTheme();

  return (
    <thead>
      <tr
        className={css({
          position: "sticky",
          top: 0,
          zIndex: 1,
          height: 50,
          borderBottom: "1px solid #D1D5DB",
          backgroundColor: "#fffffe",
        })}
      >
        {header.map((item: string, i: number) => {
          const isFirstCol = i === 0;
          return (
            <th
              key={i}
              className={css({
                width: isFirstCol ? "30%" : 50,
                textTransform: "capitalize",
                textIndent: isFirstCol ? 10 : 0,
                textAlign: "left",
                fontSize: 16,
                color: colors.CHARCOAL,
                fontWeight: 600,
                letterSpacing: "0.5px",
              })}
            >
              {isFirstCol ? item : `To ${item}`}
            </th>
          );
        })}
      </tr>
    </thead>
  );
};
